import { RegisterDetails } from '../RegisterDetails';

export function EditProfile() {
  return (
    <div>
      <RegisterDetails editing={true} />
    </div>
  );
}
